export default {
  document: {
    name: 'Document',
    search: {
      errors: {
        bilans: 'Veuillez sélectionner le(s) année(s)',
        typeDocument: 'Veuillez sélectionner le(s) type(s) de documents',
      },
    },
    list: {
      title: 'Mon Dossier Médical',
      noDataText: 'Aucun document ne correspond aux critères de recherche',
      downloadHover: 'Télécharger',
      expandHover: 'Documents joints',
      eyeHover: 'Visualiser',
      headers: {
        libelleDocument: 'Libellé',
        nomDocument: 'Nom du document',
        dateCreation: 'Date de création',
        typeDocument: 'Type de document',
        typeDocumentSearch: 'Sélectionnez le type de document',
        age: 'Age du document',
        bilans: 'Sélectionnez les années des bilans',
        selectAll: 'Tout sélectionner',
      },
      enums: {
        age: {
          onemonth: 'Acte de moins de 1 mois',
          threemonths: 'Acte de moins de 3 mois',
          sixmonths: 'Acte de moins de 6 mois',
          heightmonths: 'Acte de moins de 8 mois',
          oneyear: 'Acte de moins de 1 an',
          twoyears: 'Acte de moins de 2 ans',
          threeyears: 'Acte de moins de 3 ans',
        },
      },
    },
    send: {
      title: 'Envoyer le(s) document(s)',
      dialog: {
        mail: 'Envoyer le(s) document(s) sélectionné(s) par mail à : ',
        password: "Mot de passe demandé à l'ouverture des fichiers : ",
        data: 'Vous êtes responsable du traitement des données que vous envoyez',
      },
      input: {
        mail: 'Adresse mail',
        myself: 'Mon adresse mail',
        password: 'Mot de passe',
      },
      enCours: 'Envoi en cours',
      success: 'Document(s) envoyé(s)',
    },
    error: {
      typedocument:
        'Une erreur est survenue lors de la récupération de la liste des types documents. Veuillez contacter le CIEM.',
      selectdocument:
        'Une erreur est survenue lors du téléchargement du document.',
      bilans:
        'Une erreur est survenue lors de la récupération de la liste des bilans.',
      sendDocument: "Une erreur est survenue lors de l'envoi des documents",
      selectDocuments:
        'Une erreur est survenue lors de la récupération des documents',
      mail: 'Une erreur est survenue lors de la récupération de votre adresse mail',
    },
  },
}
